import React, { Fragment } from 'react';
import { observer } from 'mobx-react';
import { http } from '../../services/HttpInterceptor';
import {
    RouteComponentProps, Link, Redirect
} from "react-router-dom";
import { toast } from 'react-toastify';
import { observable } from 'mobx';
import InputForm from '../site/layout/InputForm';
import { sessionService } from '../../services/SessionService';

interface NewMikrotikProps extends RouteComponentProps {
    changeToggle(action?: boolean): void
}

@observer export default class NewMikrotik extends React.Component<NewMikrotikProps> {

    @observable private router: any = {
        name: "",
        ip: "",
        username: "",
        password: ""
    };
    @observable private redirect = false;
    @observable private newRouterId: string | number = "";
    @observable private validationErrors: string[] = [
        "name",
        "ip",
        "username",
        "password"
    ];

    componentDidMount() {
        this.props.changeToggle(true);
    }

    private handleChange = (event: any) => {
        const { name, value } = event.target;
        this.router[name] = value;
    }

    private setValidation = (value: boolean, name: string): void => {
        const error = this.validationErrors.indexOf(name);
        if (value && error === -1) {
            this.validationErrors.push(name);
        } else if (!value && error !== -1) {
            this.validationErrors.splice(error, 1);
        }
    }

    private pickIdFromRecord(obj: any): string | number | null {
        if (obj == null || typeof obj !== "object" || Array.isArray(obj)) {
            return null;
        }
        const id =
            obj.id ??
            obj.ID ??
            obj.id_router ??
            obj.router_id ??
            obj.mikrotik_router_id ??
            obj.insertId ??
            obj.insert_id ??
            obj.lastInsertId ??
            obj.last_insert_id;
        return id != null && String(id).trim() !== "" ? id : null;
    }

    /** Misma idea que ViewMikrotik: body con `response` o objeto plano. */
    private extractCreatedId(data: any): string | number | null {
        if (data == null) {
            return null;
        }
        const top = this.pickIdFromRecord(data);
        if (top != null) {
            return top;
        }
        let r: any = data && data.data != null ? data.data : data;
        const inner = this.pickIdFromRecord(r);
        if (inner != null) {
            return inner;
        }
        if (data.response != null) {
            r = data.response;
        } else if (r && r.response != null) {
            r = r.response;
        }
        if (Array.isArray(r)) {
            r = r[0];
        }
        if (r != null && typeof r === "object" && r.data != null) {
            r = r.data;
            if (Array.isArray(r)) {
                r = r[0];
            }
        }
        if (r == null) {
            return null;
        }
        if (typeof r === "number" || typeof r === "string") {
            const n = Number(r);
            return !isNaN(n) && String(r).trim() !== "" ? r : null;
        }
        return this.pickIdFromRecord(r);
    }

    /** Si el create no devuelve id, el listado sí trae `id` por fila (IndexMikrotik). */
    private findCreatedIdInReadList(readBody: any): string | number | null {
        const list = readBody && readBody.response;
        if (!Array.isArray(list)) {
            return null;
        }
        const ip = String(this.router.ip || "").trim();
        const name = String(this.router.name || "").trim();
        const matches = list.filter((row: any) => String(row.ip || "").trim() === ip);
        if (matches.length === 0) {
            return null;
        }
        const rowName = (row: any) => {
            const n = row.name != null && String(row.name) !== "" ? row.name : row.nombre;
            return String(n || "").trim();
        };
        const byName = name ? matches.filter((row: any) => rowName(row) === name) : [];
        const pool = byName.length > 0 ? byName : matches;
        const numeric = pool
            .map((row: any) => ({ row, n: Number(row.id) }))
            .filter((x: { row: any; n: number }) => !isNaN(x.n));
        if (numeric.length === 0) {
            return pool[0].id;
        }
        numeric.sort((a: { n: number }, b: { n: number }) => b.n - a.n);
        return numeric[0].row.id;
    }


    private onSubmit = (): void => {
        if (this.validationErrors.length > 0) {
            toast.error("Hay un error en tu formulario");
            return;
        }

        this.router.created_by = sessionService.getUserInfo().id;
        http.post(`/api/mikrotik_router/create`, JSON.stringify(this.router))
            .then((response) => {
                toast.success(`Router MikroTik agregado`);
                let id = this.extractCreatedId(response.data);
                if (id == null) {
                    return http
                        .get(`/api/mikrotik_router/read`)
                        .then((readRes) => {
                            const found = this.findCreatedIdInReadList(readRes.data);
                            if (found != null) {
                                this.newRouterId = found;
                            }
                        })
                        .catch(() => { /* sin listado igual redirigimos */ })
                        .then(() => {
                            this.redirect = true;
                        });
                }
                this.newRouterId = id;
                this.redirect = true;
            }).catch((error) => {
                if (Array.isArray(error)) {
                    error.forEach((val) => {
                        toast.error(val);
                    })
                } else {
                    toast.error(error.message || error);
                }
            });
    }

    render() {
        if (this.redirect) {
            const url = this.newRouterId ? `/mikrotik/ver/${this.newRouterId}` : "/mikrotik";
            return <Redirect to={url} />
        }
        return (
            <Fragment>
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-header card-header-rose card-header-text">
                                <div className="card-text">
                                    <h4 className="card-title">Nuevo router: {this.router.name}</h4>
                                </div>
                            </div>
                            <div className="card-body ">
                                <div className="row">
                                    <div className="col-sm-10"></div>
                                    <div className="col-sm-2">
                                        <Link to={`/mikrotik`}>
                                            <button className="btn btn-danger btn-sm pull-right">
                                                <i className="material-icons">highlight_off</i>
                                                <div className="ripple-container"></div>
                                            </button>
                                        </Link>
                                    </div>
                                </div>
                                <InputForm
                                    name="name"
                                    label="Nombre"
                                    value={this.router.name}
                                    setValidation={this.setValidation}
                                    required={true}
                                    onChange={this.handleChange}
                                    type="text"
                                />
                                <InputForm
                                    name="ip"
                                    label="IP"
                                    value={this.router.ip}
                                    setValidation={this.setValidation}
                                    required={true}
                                    onChange={this.handleChange}
                                    type="text"
                                />
                                <InputForm
                                    name="username"
                                    label="Usuario"
                                    value={this.router.username}
                                    setValidation={this.setValidation}
                                    required={true}
                                    onChange={this.handleChange}
                                    type="text"
                                />
                                <InputForm
                                    name="password"
                                    label="Password"
                                    value={this.router.password}
                                    setValidation={this.setValidation}
                                    required={true}
                                    onChange={this.handleChange}
                                    type="password"
                                    enforceStrongPassword={false}
                                    showPasswordToggle={true}
                                />
                                <div className="row">
                                    <div className="col-md-12">
                                        <button onClick={this.onSubmit} type="button" className="btn btn-primary pull-right">Crear</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment >
        )
    }
}
